import moment from "moment";
import { message } from "antd";
import api from "@/services";

export const test = {
  state: {
    fields: undefined,
    loading: false,
  },
  reducers: {
    updateLoading: (state, payload) => {
      return { ...state, loading: payload };
    },
    updateStartPoint: (state, payload) => {
      const { fields } = state;
      return { ...state, fields: { ...fields, startPoint: payload } };
    },
    updateEndPoint: (state, payload) => {
      const { fields } = state;
      return { ...state, fields: { ...fields, endPoint: payload } };
    },
    updateFields: (state, payload) => {
      const { fields } = state;
      const { time, vertex, ...rest } = payload
      if (time) {
        return {
          ...state, fields: { time }
        }
      }
      return { ...state, fields: { ...fields, ...rest, ...vertex } };
    },
    reset: (state, payload) => {
      return {
        loading: false,
        fields: undefined,
      };
    },
  },
  effects: (dispatch) => ({
    async loadNavigate(payload) {
      this.updateLoading(true);
      const { time, vertex } = payload;
      const { startPoint, endPoint } = vertex;
      const response = await api.plan({ date: time.format("YYYYMMDD"), startPoint: startPoint, endPoint: endPoint });
      console.log(response)

      if (response.status !== 200) {
        message.error(response.des, 10);
      }
      this.updateLoading(false);
    },
    async evaluate(payload) {
      const response = api.evaluate();
      console.log(response);
    }
  }),
  selectors: (slice, createSelector) => ({
    selectLoading() {
      return slice((layer) => layer.loading);
    },

    selectStartPoint() {
      return slice((layer) => layer.fields?.startPoint);
    },
    selectEndPoint() {
      return slice((layer) => layer.fields?.endPoint);
    },
    selectPoints() {
      return slice((layer) => {
        return {
          startPoint: layer.fields?.startPoint,
          endPoint: layer.fields?.endPoint,
        };
      });
    },
    selectDrawing() {
      return slice((layer) => layer.fields?.drawing);
    },
    selectFields() {
      return slice((layer) => {
        const drawing = layer.fields?.drawing;
        const startPoint = layer.fields?.startPoint;
        const endPoint = layer.fields?.endPoint;
        const result = [];
        result.push({
          name: ["time"],
          value: moment("2021-09-10"),
        });
        result.push({
          name: ["vertex"],
          value: { drawing, startPoint, endPoint },
        });
        return result;
      });
    },
  }),
};
